<template>
  <!-- Teleported to body so it isn't trapped under Vuetify dialogs/overlays (which also live on body) -->
  <Teleport to="body">
    <transition name="slide-down">
      <div v-if="allNotifications.length > 0" class="notifications-list">
        <NotificationMessage
            v-for="notification in allNotifications"
            :key="notification.id"
            :notification="notification"
        />
      </div>
    </transition>
  </Teleport>
</template>

<script>

import {computed} from "vue";
import { useStore } from 'vuex';
import NotificationMessage from "@/components/notifications/NotificationMessage.vue";

export default {

  name: "NotificationsList",

  components: {
    NotificationMessage,
  },

  setup() {

    const store = useStore();

    const allNotifications = computed(() => store.getters["notifications/getNotifications"]);

    return {
      allNotifications,
    }

  },

}
</script>

<style lang="scss" scoped>
.notifications-list {
  position: fixed;
  width: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  // above Vuetify dialogs (2000+, +10 per stacked dialog) and the loading Overlay (5000),
  // below UpdateOverlay (9999) and OfflineIndicator (10000)
  z-index: 9000;
  border-radius: 0;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

/* Slide-down animation */
.slide-down-enter-active,
.slide-down-leave-active {
  //transition: transform 0.3s ease, opacity 0.3s ease;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
  opacity 0.25s ease;
}
.slide-down-enter-from {
  transform: translate(-50%, -100%); /* Start above viewport */
  opacity: 0;
}
.slide-down-enter-to {
  transform: translate(-50%, 0); /* End at top */
  opacity: 1;
}
.slide-down-leave-from {
  transform: translate(-50%, 0);
  opacity: 1;
}
.slide-down-leave-to {
  transform: translate(-50%, -100%);
  opacity: 0;
}

</style>
